import React from 'react';
import icon from '@uswds/uswds/img/sprite.svg';
import propTypes from "prop-types";

const  Icon = ({children, ...rest}) => {

  return  (
    <svg className={`usa-icon ${rest.iconStyle}`} aria-hidden={rest.ariaHidden} focusable="false" role="img" aria-label={rest.ariaLabel}>
      <use xlinkHref={`${icon}#${rest.iconName}`}></use>
      {children}
  </svg>
  )
};

export default Icon;

Icon.propTypes = { 
  iconStyle: propTypes.oneOfType([propTypes.string]),
  iconName: propTypes.oneOfType([propTypes.string]),
  ariaHidden: propTypes.oneOf([true, false]),
  ariaLabel: propTypes.oneOfType([propTypes.string])
}
Icon.defaultProps = {
  iconStyle: "",
  iconName: "",
  ariaHidden: false,
  ariaLabel: ""
}